import * as React from 'react';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import type { OwaDate } from 'owa-datetime';
import type { ProjectId, AssetId } from 'owa-timestream-types';
import { SET_DUE_DATE_COMMAND_ID } from '../constants';
import DueDateMenuPicker from '../components/DueDateMenuPicker';
import loc from 'owa-localize';
import { setDueDateText } from 'owa-locstrings/lib/strings/setduedatetext.locstring.json';

export default function getDueDateMenuPicker(
    projectId: ProjectId,
    assetId: AssetId,
    selectedDate: OwaDate | undefined,
    isCompleted: boolean | undefined,
    deleteTaskOnDateRemoval: boolean,
    onSetDueDate?: (date: OwaDate | null) => void,
    onRemoveDueDate?: () => void,
    onSetComplete?: (isComplete: boolean) => void
): IContextualMenuItem[] {
    return [
        {
            key: SET_DUE_DATE_COMMAND_ID,
            title: loc(setDueDateText),
            onRender: customRenderDueDateMenuPicker,
            data: {
                projectId,
                assetId,
                selectedDate,
                isCompleted,
                onSetDueDate,
                onRemoveDueDate,
                onSetComplete,
                deleteTaskOnDateRemoval,
            },
        },
    ];
}

function customRenderDueDateMenuPicker(
    item: IContextualMenuItem,
    dismissMenu: (ev?: any, dismissAll?: boolean) => void
) {
    const {
        projectId,
        assetId,
        selectedDate,
        isCompleted,
        onSetDueDate,
        onRemoveDueDate,
        onSetComplete,
        deleteTaskOnDateRemoval,
    } = item.data;

    return (
        <DueDateMenuPicker
            projectId={projectId}
            assetId={assetId}
            selectedDate={selectedDate}
            isCompleted={isCompleted}
            deleteTaskOnDateRemoval={deleteTaskOnDateRemoval}
            dismissMenu={dismissMenu}
            onSetDueDate={onSetDueDate}
            onRemoveDueDate={onRemoveDueDate}
            onSetComplete={onSetComplete}
        />
    );
}
